export const dealTypesById = {
  1: 'sale',
  2: 'rent',
  3: 'holiday_rent',
  4: 'rural_rent',
  5: 'shared_flat',
  6: 'rent_parking',
  7: 'sale_parking',
  8: 'rent_office',
  9: 'sale_office',
  10: 'sale_terrain',
  11: 'transfer_local',
  12: 'rent_local',
  13: 'sale_local',
  14: 'rent_industrial_ship',
  15: 'sale_industrial_ship',
  16: 'sale_overseas',
  17: 'temporally_rent',
  18: 'sale_unlisted_foreclosure',
};

export const dealTypesByString = {
  sale: 1,
  rent: 2,
  holiday_rent: 3,
  rural_rent: 4,
  shared_flat: 5,
  rent_parking: 6,
  sale_parking: 7,
  rent_office: 8,
  sale_office: 9,
  sale_terrain: 10,
  transfer_local: 11,
  rent_local: 12,
  sale_local: 13,
  rent_industrial_ship: 14,
  sale_industrial_ship: 15,
  sale_overseas: 16,
  temporally_rent: 17,
  sale_unlisted_foreclosure: 18,
};

export const dealTypeIdToString = id => dealTypesById[id];
export const dealTypeStringToId = string => dealTypesByString[string];



// WEBPACK FOOTER //
// ./app/utils/dealType.js